import UserRolePermission from "@mixins/UserRolePermission";

//acl = access control list
function Install(Vue) {
    Vue.acl = UserRolePermission
    Vue.prototype.$acl = UserRolePermission
}

export default Install
